import {request,post} from '@/utils/request.js';
//仪表盘相关接口
//获取账号列表
export const getAccountList =(params)=> request('/api/account/accountlist', {params:{...params}});
//获取账号详情
export const getAccountDetail = ({account='',type=''})=> request('/api/account/dashboard',{params:{account:account,type}});
//获取日统计折线图
export const getDayCharts = ({account='',type='',cate=''})=>request('/api/account/chartday',{params:{account,type,cate}})
//获取日达标统计折线图
export const getInfoCharts = ({account='',type=''})=>request('/api/account/chartinfo',{params:{account,type}})
//获取实际收益率明细每日有效2%
export const getYieldRateList = ({account='',type=''})=>request('/api/user/truefundget',{params:{account,type}})
//通关提交审核
export const updateReview = ({type,account})=>request('/api/account/passapply',{...post,data:{type,account}});
//仪表盘分享
export const getAccountShare = ({account='',type=''})=> request('/api/account/share',{params:{account:account,type}});
// 免费账号重置
export const postFreeReset = (data)=>request('/api/openuser/freereset',{...post,data});


//修改交易账户密码
export const updatePassword = ({type,pwd,account_no})=>request('/api/account/accountuppwd\n',{...post,data:{type,pwd,account_no}});
//获取付费记录
export const getPayLogList = ({start=0,count=10,...rest})=> request('/api/pay/paylog',{params:{start,count,...rest}})
// 获取发票信息
export const getInvoiceInfo =(id)=> request(`/api/pay/billinfo?id=${id}`);
//获取订单详情
export const getOrderDetail = (id)=> request(`/api/pay/payinfo`,{params:{id}});

// 获取积分产品兑换列表
export const getProductExchangeList =()=> request('/api/point/product');
// 积分兑换产品
export const pointsRedemption = ({pid})=>request('/api/point/redeemproduct',{...post,data:{pid}});

// 获取我的资产
export const getMyAssets =()=> request('/api/wallet/center');
//收入明细
export const getIncomeList = ({start=0,count=10})=> request('/api/wallet/incomelist',{params:{start,count}})
//提现明细
export const getWithdrawList = ({start=0,count=10})=> request('/api/wallet/withdrawlist',{params:{start,count}})
// 获取银行列表
export const getBankList =()=> request('/api/index/banklist');
// 获取支行列表
export const getSubBankList =(params)=> request('/api/index/subbank',{params:{...params}});
// 获取我的银行列表
export const getWalletBankList =(params)=> request('/api/wallet/bankcardlist',{params:{...params}});
//添加银行卡
export const postAddBankCard = (data={})=>request('/api/wallet/bankcardadd',{...post,data});
//编辑银行卡
export const postEditBankCard = (data={})=>request('/api/wallet/bankcardup',{...post,data});
//银行卡详情
export const getBankCardDetail =(id)=> request(`/api/wallet/bankcardinfo`,{params:{id}});
//删除银行卡
export const delBankCard =(id)=> request(`/api/wallet/bankcarddel?id=${id}`);
// 获取余额
export const getBalance =()=> request('/api/wallet/balance');
//提现申请
export const updateWithdrawal = (data={})=>request('/api/wallet/withdrawapply',{...post,data});
// 获取提现确认页
export const getWithdrawalConfirm =({cardid='',money=''})=> request('/api/wallet/withdrawcheck',{params:{cardid,money}});
//提现详情
export const getPaymentDetail =(id)=> request(`/api/wallet/withdrawinfo?id=${id}`);
